export default __webpack_public_path__ + "static/media/3.7e67154f.png";